import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {FaVuejs,FaGitAlt} from "react-icons/fa";
import {
  DiJavascript1,
  DiNodejs,
  DiPython,
  DiSqllite,
  DiJava,
  
} from "react-icons/di";
import { SiLaravel,SiPhp,SiMysql,SiOracle,SiMicrosoftsqlserver,SiBootstrap,SiIonic } from "react-icons/si";

function handleClick(url) {
  window.open(url, '_blank').focus();
}

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
     
      <Col onClick={() => handleClick("https://www.php.net/")} xs={4} md={2} className="tech-icons">
        <SiPhp/>
      </Col>
      <Col onClick={() => handleClick("https://www.java.com/")} xs={4} md={2} className="tech-icons">
        <DiJava/>
      </Col>
      <Col onClick={() => handleClick("https://isocpp.org/")} xs={4} md={2} className="tech-icons">
        <CgCPlusPlus />
      </Col>
      <Col onClick={() => handleClick("https://www.javascript.com/")} xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col onClick={() => handleClick("https://www.python.org/")} xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>

      <Col onClick={() => handleClick("https://laravel.com/")} xs={4} md={2} className="tech-icons">
        <SiLaravel />
      </Col>
      <Col onClick={() => handleClick("https://nodejs.dev/")} xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col onClick={() => handleClick("https://ionicframework.com/")} xs={4} md={2} className="tech-icons">
        <SiIonic />
      </Col>
      
      <Col onClick={() => handleClick("https://vuejs.org/")} xs={4} md={2} className="tech-icons">
        <FaVuejs />
      </Col>
      <Col onClick={() => handleClick("https://getbootstrap.com/")} xs={4} md={2} className="tech-icons">
        <SiBootstrap />
      </Col>
      
      <Col onClick={() => handleClick("https://www.mysql.com/")} xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col onClick={() => handleClick("https://www.oracle.com/id/index.html")} xs={4} md={2} className="tech-icons">
        <SiOracle />
      </Col>
      <Col onClick={() => handleClick("https://www.sqlite.org/index.html")} xs={4} md={2} className="tech-icons">
        <DiSqllite />
      </Col>
      <Col onClick={() => handleClick("https://www.microsoft.com/en-us/sql-server")} xs={4} md={2} className="tech-icons">
        <SiMicrosoftsqlserver />
      </Col>
      <Col onClick={() => handleClick("https://git-scm.com/")} xs={4} md={2} className="tech-icons">
        <FaGitAlt />
      </Col>
      
      
    </Row>
  );
}

export default Techstack;
